import { useId } from 'react';
import { halo, sparkleRotate } from './sparkle.css';

export type SparkleProps = {
  style?: React.CSSProperties;
  className?: string;
  size?: number;
};

export const Sparkle = ({ style, className, size = 24 }: SparkleProps) => {
  const id = useId();
  const sparkleSize = size * 0.55;
  const sparkleOffset = (size - sparkleSize) / 2;

  return (
    <div
      className={className}
      style={{
        position: 'relative',
        borderRadius: size / 2,
        width: size,
        height: size,
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(255, 255, 255, 0.14)',
        ...style,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <defs>
          <linearGradient id={`halo-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#00ffec" />
            <stop offset="50%" stopColor="#ff00f2" />
            <stop offset="100%" stopColor="#00ff5b" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size * 0.4}
          fill={`url(#halo-${id})`}
          className={halo}
        />
      </svg>
      <svg
        width={sparkleSize}
        height={sparkleSize}
        viewBox="0 0 14 15"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: sparkleOffset,
          left: sparkleOffset,
        }}
        className={sparkleRotate}
      >
        <defs>
          <linearGradient id={`sparkle-${id}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#f5f0ff" />
          </linearGradient>
        </defs>
        <path
          fill={`url(#sparkle-${id})`}
          d="M7 0.714966C6.57172 0.714966 6.19841 1.00644 6.09453 1.42193C5.64458 3.22175 5.11525 4.31311 4.3567 5.07167C3.59815 5.83022 2.50678 6.35955 0.706966 6.8095C0.291477 6.91337 0 7.28669 0 7.71497C0 8.14324 0.291477 8.51656 0.706966 8.62043C2.50678 9.07039 3.59815 9.59971 4.3567 10.3583C5.11525 11.1168 5.64458 12.2082 6.09453 14.008C6.19841 14.4235 6.57172 14.715 7 14.715C7.42828 14.715 7.80159 14.4235 7.90547 14.008C8.35542 12.2082 8.88475 11.1168 9.6433 10.3583C10.4019 9.59971 11.4932 9.07039 13.293 8.62043C13.7085 8.51656 14 8.14324 14 7.71497C14 7.28669 13.7085 6.91337 13.293 6.8095C11.4932 6.35955 10.4019 5.83022 9.6433 5.07167C8.88475 4.31311 8.35542 3.22175 7.90547 1.42193C7.80159 1.00644 7.42828 0.714966 7 0.714966Z"
        />
      </svg>
    </div>
  );
};
